module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "CO1 para-style-override-7"
  }, [_vm._v("contents")])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "Headnote"
  }, [_c('a', {
    attrs: {
      "href": "#/page05_intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('a', {
    attrs: {
      "href": "#/page06_fashion"
    }
  }, [_c('span', {
    staticClass: "C1 char-style-override-24",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Fashion")]), _vm._v(" "), _c('span', {
    staticClass: "C2 char-style-override-25",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Mavens")])])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page07_tom",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "C1 char-style-override-24",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Tomboys")])])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page08_global",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "C1 char-style-override-24",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Global")]), _c('span', {
    staticClass: "C2 char-style-override-25",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "C2 char-style-override-25",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Travelers")])])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page09_thrill",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "C1 char-style-override-24",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Thrill")]), _c('span', {
    staticClass: "C1 char-style-override-24",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "C2 char-style-override-25",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("Seekers")])])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page10_special",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Special Techniques")])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page11_abbr",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page12_sources",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources for Supplies")])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page13_biblio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page14_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page15_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index"), _c('span', {
    staticClass: "indent"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "Headnote"
  }, [_c('span', {
    attrs: {
      "href": "#/page16_author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('div', {
    staticClass: "frame-2"
  }, [_c('img', {
    staticClass: "frame-5",
    attrs: {
      "alt": "PG5",
      "src": "images/PG5_fmt.jpeg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25d12f64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page04_toc.vue
// module id = 66
// module chunks = 0